import Search from "../pages/DSC_partial_Search";
import Dashboard from "../pages/DSC_partial_Dashboard";
import TransactionSummary from "../pages/PCC_partial_TransactionSummary";
import Breadcrumbs from '../../src/components/Breadcrumbs';
import React, { useEffect } from 'react';
import Swal from 'sweetalert2';

const PaymentChangeCalculator = () => {

   useEffect(() => {
    Swal.fire({
        icon: "warning",
        title: "Reminder to all users",
        text: "This page is currently intended for testing only. For any concerns, please reach out to the development team.",
        confirmButtonColor: '#A5CC2D', 
      });
  }, []);


  return (
      <div className="app-container">
         <div className="container">
            <h1>Payment Change Calculator</h1>
            <Breadcrumbs />
            <Dashboard />
            <div className="app-column">
                <TransactionSummary />
            </div>
            <label className="custom-footer">© 2025 Pacific Debt Relief. All rights reserved. </label>
            <br/> <br/> <br/> <br/>
          </div> 
      </div>
  );
};

export default PaymentChangeCalculator;